import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

export default class ComponentHeader {
    constructor() {
        this.slider = document.querySelector(".swiper--component-header")
        this.navigationPrev = document.querySelector(".slider-button-prev--component-header")
        this.navigationNext = document.querySelector(".slider-button-next--component-header")
        this.pagination = document.querySelector(".slider-pagination--component-header")

        this.btnOpenVideo = this.slider.querySelectorAll('[data-video]')
        this.modalVideo = document.querySelector('.modal-video')
        this.videoLocal = this.modalVideo.querySelector('#video-container')
        this.btnCloseModalVideo = this.modalVideo.querySelector('.closeModal')

        this.tabsItems = document.querySelectorAll('.widget-compoment .tabs .tab')
        this.tabsMenu = document.querySelectorAll('.widget-compoment .menuTabs ul li div')

        this.quartosHospedagem = document.querySelector('.quartoQt select')

        this.ready();
        this.tabs();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination, Autoplay],
            grabCursor: true,
            spaceBetween: 0,
            slidesPerView: 1,
            allowTouchMove: true,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            },
            pagination: {
                el: this.pagination,
                clickable: true,
            }
        })

        this.btnOpenVideo.forEach(el => {
            el.addEventListener('click', () => {
                const video = el.getAttribute('data-video')

                let iframe = document.createElement( "iframe" );

                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "");
                iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                // Important: add the autoplay GET parameter, otherwise the user would need to click over the YouTube video again to play it 
                iframe.setAttribute("src", video);

                // Clear Thumbnail and load the YouTube iframe
                this.videoLocal.innerHTML = "";
                this.videoLocal.appendChild( iframe );

                this.modalVideo.classList.add('active')
                this.btnCloseModalVideo.addEventListener('click', () => {
                    this.modalVideo.classList.remove('active')
                    this.videoLocal.innerHTML = "";
                })
            })
        })

        this.quartosHospedagem.addEventListener('change', () => {
            setTimeout(() => {
                this.checkRooms()
            }, 100);
        })
    }

    checkRooms() {
        const quartosItems = document.querySelectorAll('.quartoItem')
        if(+this.quartosHospedagem.value > 1) {
            quartosItems.forEach(el => {
                el.classList.add('addBorder')
            })
        }
    }

    tabs() {
        this.tabsMenu.forEach((menu) => {
            menu.addEventListener('click', () => {

                const tabItem = menu.dataset.tab;

                this.tabsMenu.forEach((me) => {
                    me.classList.remove('active')
                })

                menu.classList.add('active')

                this.tabsItems.forEach((tab) => {
                    tab.classList.remove('active')
                    tab.classList.add('blockScrool')
                })

                document.querySelector(`#tab-${tabItem}`).classList.remove('blockScrool')
                document.querySelector(`#tab-${tabItem}`).classList.add('active')
            })
        })
    }
}